<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranihPodatkovStranke="GetStranka" :selectorPermissions="selectorPermissions" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            Telefonija
          </p>
          <div v-if="seznamNosilnihPrikljuckov.length !== 0">
            <div v-if="seznamNosilnihPrikljuckov.length > 1 && activetab === 't1'" style="padding-top: 20px">
              <p>
                Izbrani priključek
                <IzbirnikPrikljuckaSelect
                  @novIzbranPrikljucek="izbranPrikljucek = $event"
                  style-class="izbirnik-prikljuckov"
                  :izbranPrikljucek="izbranPrikljucek"
                  :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
                />
              </p>
            </div>
            <div style="padding-top: 15px">
              <el-tabs type="border-card" @tab-click="HandleTabClick" :value="activetab">
                <el-tab-pane label="Telefonija" name="t1" ref="t1">
                  <div v-if="activetab === 't1'">
                    <Telefonija
                      :izbranPrikljucek="izbranPrikljucek"/>
<!--                      v-on:cenikStoritevTelefonija="GetCenik"-->
                  </div>
                </el-tab-pane>
<!--                <el-tab-pane label="eTelefon" name="t2" ref="t2">-->
<!--                  <div v-if="activetab === 't2'">-->
<!--                    <e-telefon :izbranPrikljucek="izbranPrikljucek"-->
<!--                               :cenikSPremembeStoritevTelefonija="cenikSPremembeStoritevTelefonija"-->
<!--                               :gsmOdStranke="gsmOdStranke"/>-->
<!--                  </div>-->
<!--                </el-tab-pane>-->
                <el-tab-pane label="Enote" name="t3" ref="t3" v-if="showUnits">
                  <div v-if="activetab === 't3'">
                    <Enote
                      :izbranaSap="izbranaSap"/>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div v-if="seznamNosilnihPrikljuckov.length === 0 && !pridobivanjePodatkov">
            <div class="obvestilo-prazen-seznam">
              <p>
                Na izbrani naročnini ni možno naročati storitev stacionarne telefonije.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IzbirnikPrikljuckov from '../GlobalneKomponente/IzbirnikPrikljuckov'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import Telefonija from './NarociTelefonija/Telefonija'
import ETelefon from './NarociTelefonija/eTelefon'
import Enote from './NarociTelefonija/Enote'
import {TabPane, Tabs, Option, Select} from 'element-ui'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {UrejenSeznamPrikljuckov} from '../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'
import IzbirnikPrikljuckaSelect from '../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'

export default {
  name: 'NarociTelefonija',
  mixins: [GetPodatkiIzbirnika],
  data () {
    return {
      clientAgent: null,
      izbranPrikljucek: '',
      izbranaSap: '',
      idStranka: '',
      activetab: 't1',
      // cenikSPremembeStoritevTelefonija: [],
      gsmOdStranke: '',
      selectorPermissions: ['STRANKE_S_PRIKLJUCKI'],
      seznamNosilnihPrikljuckov: [],
      seznamPrikljuckovGrupirano: [],
      pridobivanjePodatkov: true,
      seznamPrikljuckov: [],
      izbranaStranka: null,
      showUnits: false
    }
  },
  components: {
    IzbirnikPrikljuckaSelect,
    IzbirnikStranke,
    Enote,
    ETelefon,
    Telefonija,
    'IzbirnikPrikljuckov': IzbirnikPrikljuckov,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs,
    [Select.name]: Select,
    [Option.name]: Option
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.idStranka = podatkiStranke.id_stranka
        this.izbranaSap = podatkiStranke.id_stranka_sap
        this.izbranaStranka = podatkiStranke
        this.GetPrikljuckiDovoljenja(podatkiStranke.id_stranka)
        this.showUnits = false
        let param = ['permissionId=STRANKE_S_PRIKLJUCKI_S_TS']
        param.push('filter[id_stranka]=' + this.idStranka)
        this.clientAgent.postWsRequest(
          this,
          '/permissions/havePermission',
          param,
          null,
          'SetShowUnits',
          'ErrShowUnits')
      }
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.idStranka = prenosniParamIdStranka
        let param = ['permissionId=PRIKLJUCKI']
        param.push('filter[tip_prikljucka]=FIX')
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckovGrupirano = []
      this.seznamVsehPrikljuckov = []
      this.izbranPrikljucek = ''
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka.id_stranka,
        podatki.permission.additionalData
      )
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamNosilnihPrikljuckov = list
      this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      this.seznamPrikljuckovGrupirano = groupedList
      this.PridobitevTrenutniNarocnik()
      this.pridobivanjePodatkov = false
    },
    ErrPrikljuckiDovoljenja (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    HandleTabClick (tab) {
      this.activetab = tab.name
    },
    // GetCenik  (cenik) {
    // this.cenikSPremembeStoritevTelefonija = []
    // for (let i = 0; i < cenik.length; i++) {
    //   this.cenikSPremembeStoritevTelefonija.push(cenik[i])
    // }
    // },
    PridobitevTrenutniNarocnik () {
      if (this.idStranka !== '') {
        let param = ['permissionId=STRANKE']
        param.push('filter[id_stranka]=' + this.idStranka)
        this.clientAgent.postWsRequest(
          this,
          '/permissions/havePermission',
          param,
          null,
          'SetPridobitevTrenutniNarocnik',
          'ErrPridobitevTrenutniNarocnik')
      }
    },
    SetPridobitevTrenutniNarocnik (podatki) {
      this.gsmOdStranke = ''
      this.gsmOdStranke = podatki.permission.additionalData[0].gsm
    },
    SetShowUnits (data) {
      this.showUnits = data.permission.additionalData.length > 0
      if (!this.showUnits) {
        this.activetab = 't1'
      }
    },
    ErrShowUnits (data) {
      this.ShowWarningMessage(data)
    }
  }
}
</script>
<style scoped src="../../../../../static/css/Naroci/NarociTelefonija/Telefonija.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelefonija.vue